import { createComponent } from '@mtfe/sweet';
import { common, dom, timeFormat } from '@mtfe/sweet-utils';

import FocusModal from '../FocusModal/script';
import ConfirmModal, { hideConfirmModal } from '../ConfirmModal/script';
import ConvertRedBagModal, {
    hideConvertRedBagModal,
} from '../ConvertRedBagModal/script';
import NewLoginModal from '../NewLoginModal/script';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId, qsParse } = common;
const NOT_LOGIN = 0;
const TASK_IN_PROGRESS = 1;
const TASK_STOP = 2;
const ACTIVITY_ID = createUniqueId();

let propsCache = null;

/**
 * 调用获取活动信息接口，对活动数据做进一步处理，并写入global
 * @param {Object} http http请求
 * @param {Object} global 全局对象
 * @returns
 */
const callIncentiveActivityInfo = async (http, global) => {
    try {
        // 1.接口获取数据
        const activityInfo = await http.postActivityInfo();

        // 2.接口异常处理
        if (!activityInfo) {
            return null;
        }

        // 3.业务数据处理
        const { data } = activityInfo;
        global.phone = data.phone;

        if (!data.isActivityOn) {
            return data;
        }
        const {
            periodEndTime,
            periodStartTime,
            taskProgress,
            completedOrderCnt,
            readyOrderCnt,
        } = data;

        const taskLength = data.taskTargetList.length;
        const taskLengthIndex = taskLength - 1;
        data.taskTargetList = data.taskTargetList.map((item) => item / 100);
        data.periodStartTime = timeFormat(
            periodStartTime * 1000,
            'MM月dd日 hh:mm',
        );
        data.periodEndTime = timeFormat(periodEndTime * 1000, 'MM月dd日 hh:mm');
        // 是否有活动中订单
        // taskProgress % 1 === 0.5 代表有配送中订单
        // taskProgress < taskLengthIndex 代表没有到达最大金额红包
        data.isHasProcess =
            Math.abs(taskProgress % 1) === 0.5 &&
            taskProgress < taskLengthIndex;
        // 任务进度 如果超过最大金额红包则返回最大金额索引否则返回当前任务索引
        data.taskProgress =
            taskProgress >= taskLengthIndex
                ? taskLengthIndex
                : Math.floor(taskProgress);
        data.currentCoupon =
            data.taskProgress >= 0 ? data.taskTargetList[data.taskProgress] : 0;
        data.allOrderCnt = completedOrderCnt + readyOrderCnt;

        global.periodEndTime = data.periodEndTime;
        global.periodStartTime = data.periodStartTime;

        return data;
    } catch (error) {
        console.error(error);
    }
    return null;
};

const renderIncentiveActivity = async (props = {}, onRenderDone) => {
    propsCache = { ...propsCache, ...props };
    const { http, global } = propsCache;
    // 1.获取数据
    const activityData = await callIncentiveActivityInfo(http, global);
    // 2.业务异常处理
    if (!activityData) {
        return false;
    }
    // eslint-disable-next-line
    const newComp = IncentiveActivity({
        ...propsCache,
        activityData,
    });
    dom.$id(ACTIVITY_ID).outerHTML = newComp;
    if (onRenderDone instanceof Function) {
        onRenderDone(activityData);
    }
    return true;
};
/**
 * 激励组件
 * @param {*} props
 * @returns
 */
const IncentiveActivity = (props = {}) => {
    propsCache = { ...propsCache, ...props };
    const { activityData, oadLX, loadLogin, loginSuccessCb, http, global } =
        propsCache;

    // 参数检查
    if (!activityData) {
        throw new Error('IncentiveActivity: activityData is undefined');
    }
    if (!loadLogin) {
        throw new Error('IncentiveActivity: loadLogin is undefined');
    }
    if (!(loginSuccessCb instanceof Function)) {
        throw new Error('IncentiveActivity: loginSuccessCb is undefined');
    }
    if (!http) {
        throw new Error('IncentiveActivity: http is undefined');
    }
    if (http.postActivityInfo === undefined) {
        throw new Error(
            'IncentiveActivity: http.postActivityInfo is undefined',
        );
    }
    if (!global) {
        throw new Error('IncentiveActivity: global is undefined');
    }

    const {
        isLastDay,
        periodStartTime,
        periodEndTime,
        taskTargetList,
        isHasProcess,
        taskProgress,
        completedOrderCnt,
        readyOrderCnt,
        taskStatus,
        currentCoupon,
        allOrderCnt,
    } = activityData;
    const events = {
        clickRemind: () => {
            const queryInSearch =
                qsParse(window.location.search.slice(1)) || {};

            const valLab = {
                pageSrc1: queryInSearch.pageSrc1,
                pageSrc2: queryInSearch.pageSrc2,
                pageSrc3: queryInSearch.pageSrc3,
            };

            // 上报灵犀(点击提醒)
            if (oadLX) {
                oadLX.mc('b_waimai_byq4qhi3_mc', {
                    custom: { valLab },
                });
            }

            FocusModal({
                onCopyClick: () => {
                    // 上报灵犀(点击复制)
                    oadLX && oadLX.mc('b_waimai_nyza2hri_mc', valLab);
                },
            });
            return false;
        },
        clickToRulePage: () => {
            // 上报灵犀(点击规则)
            oadLX && oadLX.mc('b_waimai_ry26dium_mc');
            window.location.href = '#rule';
            return false;
        },
        clickToGetCoupon: async () => {
            // 上报灵犀(点击兑换红包)
            oadLX && oadLX.mc('b_waimai_8sh1d2qy_mc');
            await renderIncentiveActivity({}, (newActivityData) => {
                if (
                    newActivityData.taskStatus !== TASK_IN_PROGRESS ||
                    newActivityData.currentCoupon === 0
                ) {
                    return false;
                }
                const postCoupon = async () => {
                    try {
                        const res = await http.postActivityCoupon({
                            couponValue: newActivityData.currentCoupon * 100,
                        });
                        const { data } = res;
                        ConvertRedBagModal({
                            title: '公众号“美团外卖袋鼠君”,周周领红包',
                            redBagCash: data.couponValue / 100,
                            redBagCanUseRule: `满${
                                data.couponLimit / 100
                            }元可用`,
                            expirationDate: timeFormat(
                                data.expireTime * 1000,
                                'yyyy.MM.dd',
                            ),
                            onUseRedBag: () => {
                                hideConvertRedBagModal();
                            },
                        });
                        await renderIncentiveActivity();
                    } catch (error) {
                        console.error('error', error);
                    }
                };
                if (newActivityData.isHasProcess) {
                    ConfirmModal({
                        title: '确认兑换为红包吗？',
                        confirmBody:
                            '当前还有订单未送达，兑换后本周将不再累积红包金额，是否确认兑换？',
                        confirmButtonText: '确认兑换',
                        cancelButtonText: '我再想想',
                        onConfirm: async () => {
                            hideConfirmModal();
                            await postCoupon();
                        },
                        onCancel: () => {
                            hideConfirmModal();
                        },
                    });
                } else {
                    ConfirmModal({
                        title: '确认兑换为红包吗？',
                        confirmBody:
                            '兑换后本周将不再累积红包金额，是否确认兑换？',
                        confirmButtonText: '确认兑换',
                        cancelButtonText: '我再想想',
                        onConfirm: async () => {
                            hideConfirmModal();
                            await postCoupon();
                        },
                        onCancel: () => {
                            hideConfirmModal();
                        },
                    });
                }
            });
            return false;
        },
        clickIncentiveActivity: () => {
            if (taskStatus === 0) {
                NewLoginModal({
                    loadLogin,
                    loginSuccessCb,
                });
            }
            return false;
        },
    };

    const data = {
        ACTIVITY_ID,
        NOT_LOGIN,
        TASK_IN_PROGRESS,
        TASK_STOP,
        isLastDay, // 是否最后一天
        periodStartTime,
        periodEndTime,
        taskTargetList,
        isHasProcess, // 是否有进行中订单
        taskProgress, // 任务进度 -1表示未达到任何目标
        completedOrderCnt, // 完成订单的数量
        readyOrderCnt, // 进行中订单的数量
        taskStatus, // 0:位置状态，一般用于用户未登录。1:任务进行中。2:用户领券，任务终止。
        currentCoupon, // 当前累计的金额
        allOrderCnt,
    };

    return createComponent(tpl, { style, data }, events);
};

export default IncentiveActivity;
export { renderIncentiveActivity, callIncentiveActivityInfo };
